/*
 * File: GuarantorDetails.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates and styles the Gaurantor view
 */
import React from "react";
import PatientPropertyList from "../../components/PatientPropertyList";
import PatientChart from "services/patients/topofthechart/PatientChart";
import { withStyles } from "@material-ui/core/styles";
import { Toolbar } from "@material-ui/core";
import MainHeader from "components/MainHeader";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2.5)
  }
});

const GuarantorDetails = props => {
  const guarantorType = props.match.params.guarantorType;
  const { classes, primaryGuarantor, secondaryGuarantor } = props;

  if (guarantorType === "primary") {
    return (
      <React.Fragment>
        <PatientChart />
        <Toolbar className={classes.toolbar}>
          <MainHeader
            pageTitle={
              primaryGuarantor.firstName + " " + primaryGuarantor.lastName
            }
            pageSubtitle="Guarantors"
          />
        </Toolbar>
        <PatientPropertyList person={primaryGuarantor} guarantorView={true} />
      </React.Fragment>
    );
  } else if (guarantorType === "secondary") {
    return (
      <React.Fragment>
        <PatientChart />
        <Toolbar className={classes.toolbar}>
          <MainHeader
            pageTitle={
              secondaryGuarantor.firstName + " " + secondaryGuarantor.lastName
            }
            pageSubtitle="Guarantors"
          />
        </Toolbar>
        <PatientPropertyList person={secondaryGuarantor} guarantorView={true} />
      </React.Fragment>
    );
  }
};

export default withStyles(styles)(GuarantorDetails);
